import axios from "axios";
import { LayoutGrid, Plus, Ruler, Tag, X } from "lucide-react";
import { useContext, useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import "../../../assets/css/admin/addProduct/AddProduct.css";
import Modal from "../../../components/admin/modal/ProductModel";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const MAX_IMAGES = 5;

const AddProduct = ({ isOpen, onClose, onAdd, viewAllProducts }) => {
  const fileInputRef = useRef(null);
  const { baseUrl, authToken } = useContext(AppContext);

  // ── Basic product fields ──
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [size, setSize] = useState("");
  const [category, setCategory] = useState("");
  const [images, setImages] = useState([]);
  const [description, setDescription] = useState("");
  const [keyFeatures, setKeyFeatures] = useState("");
  const [dimensions, setDimensions] = useState("");
  const [productMaterial, setProductMaterial] = useState(""); // will be shown to customer
  const [color, setColor] = useState("");
  const [allCategories, setallCategories] = useState([]);
  const [allCategoriesForMaterial, setallCategoriesForMaterial] = useState([]);

  // ── PM (Product Materials) fields ──
  const [allMaterial, setAllMaterial] = useState([]);
  const [pmCategory, setPmCategory] = useState("");
  const [material, setMaterial] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("");

  // ── Attached materials list ──
  const [attachedMaterials, setAttachedMaterials] = useState([]);

  // ── Error and loading states ──
  const [errors, setErrors] = useState({});
  const [pmErrors, setPmErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // ─────────────────────────────────────────────
  // Image helper functions

  const handleImageFiles = (files) => {
    const imageFiles = Array.from(files).filter((f) =>
      f.type.startsWith("image/"),
    );
    if (!imageFiles.length) return;
    const remaining = MAX_IMAGES - images.length;
    const toAdd = imageFiles.slice(0, remaining);
    setImages((prev) => [...prev, ...toAdd]);
    if (errors.images) setErrors((p) => ({ ...p, images: "" }));
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const removeImage = (idx) => {
    setImages((prev) => prev.filter((_, i) => i !== idx));
  };

  // ─────────────────────────────────────────────
  // function to fetch category in dropdown0

  const viewCategories = (type) => {
    axios
      .get(`${baseUrl}/admin/category/viewCategories`, {
        headers: { Authorization: `Bearer${authToken}` },
        params: { type: type },
      })
      .then((response) => {
        console.log(response.data);
        if (type == "inventory") {
          setallCategoriesForMaterial(response.data.categories);
        } else {
          setallCategories(response.data.categories);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ─────────────────────────────────────────────
  // Product material helper functions

  // function to fetch materials against selected category
  const viewAllMaterials = () => {
    axios
      .get(`${baseUrl}/admin/inventory/viewInventory`, {
        headers: { Authorization: `Bearer${authToken}` },
        params: { adcategory_id: pmCategory },
      })
      .then((response) => {
        console.log(response.data);
        setAllMaterial(response.data.allMaterial);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //function to get unit of selected material
  const viewMaterialUnit = (id) => {
    axios
      .get(`${baseUrl}/admin/products/viewMaterialUnit`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { id: id },
      })
      .then((response) => {
        console.log(response.data);
        setUnit(response.data.unit);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // fucntion to attach materials with product
  const handleAttachMaterial = () => {
    if (quantity <= 0) {
      alert("Quantity Required");
    } else {
      const formdata = new FormData();
      formdata.append("admaterial_id", material);
      formdata.append("qty", quantity);

      axios
        .post(`${baseUrl}/admin/products/addProductMaterial`, formdata, {
          headers: { Authorization: `Bearer ${authToken}` },
        })
        .then((response) => {
          console.log(response.data);
          viewAttachedMaterial();
        })
        .catch((error) => {
          console.log(error);
        });

      setMaterial("");
      setPmCategory("");
      setQuantity("");
      setUnit("");
      setPmErrors({});
    }
  };

  // function to view attached materials
  const viewAttachedMaterial = () => {
    axios
      .get(`${baseUrl}/admin/products/viewProductMaterial`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log(response.data);
        setAttachedMaterials(response.data.productMaterial);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // function to delete attached materials
  const handleDeleteMaterial = (id) => {
    setAttachedMaterials((prev) => prev.filter((m) => m.id !== id));

    const formdata = new FormData();
    formdata.append("id", id);
    axios
      .post(`${baseUrl}/admin/products/deleteProductMaterial`, formdata, {
        headers: { Authorization: `Bearer${authToken}` },
      })
      .then((response) => {
        console.log(response.data);
        viewAttachedMaterial();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ─────────────────────────────────────────────
  // FORM VALIDATION
  // ─────────────────────────────────────────────
  const validate = () => {
    const errs = {};
    if (!name.trim()) errs.name = "Product name is required";
    if (!images.length) errs.images = "At least one product image is required";
    if (!size.trim()) errs.size = "Size is required";
    if (!price || Number(price) <= 0) errs.price = "Valid price is required";
    if (!category.trim()) errs.category = "Category is required";
    return errs;
  };

  // ─────────────────────────────────────────────
  // FORM RESET
  // ─────────────────────────────────────────────
  // const resetForm = () => {
  //   setName("");
  //   setPrice("");
  //   setSize("");
  //   setCategory("");
  //   setImages([]);
  //   setMaterial("");
  //   setPmCategory("");
  //   setQuantity("");
  //   setUnit("");
  //   setAttachedMaterials([]);
  //   setErrors({});
  //   setPmErrors({});
  //   if (fileInputRef.current) fileInputRef.current.value = "";
  // };

  // ─────────────────────────────────────────────

  // function to create product
  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setIsSaving(true);

    const formdata = new FormData();
    formdata.append("name", name);
    images.forEach((file) => formdata.append("images[]", file));
    formdata.append("size", size);
    formdata.append("price", price);
    formdata.append("adcategory_id", category);
    formdata.append("description", description);
    formdata.append("keyFeatures", keyFeatures);
    formdata.append("dimensions", dimensions);
    formdata.append("material", productMaterial);
    formdata.append("color", color);

    axios
      .post(`${baseUrl}/admin/products/createProduct`, formdata, {
        headers: { Authorization: `Bearer${authToken}` },
      })
      .then((response) => {
        setIsSaving(false);
        setShowSuccess(true);
        viewAllProducts();
        console.log(response.data.message);
      })
      .catch((error) => {
        setIsSaving(false);
        console.log(error);
      });
  };

  //function to view all products

  //function to close modal
  const handleClose = () => {
    if (!isSaving) {
      // resetForm();
      onClose();
    }
  };

  useEffect(() => {
    viewAttachedMaterial();
    viewCategories("product");
    viewCategories("inventory");
  }, []);

  // To fetch materials against selected category
  useEffect(() => {
    if (pmCategory) {
      viewAllMaterials();
    }
  }, [pmCategory]);

  // To fetch unit agaist selected material
  useEffect(() => {
    if (material) {
      viewMaterialUnit(material);
    }
  }, [material]);

  // ─────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Add New Product"
      size="large"
    >
      {showSuccess ? (
        <div className="ap-success">
          <div className="ap-success-icon">✓</div>
          <h3>Product Added!</h3>
          <p>The new product has been added to your inventory successfully.</p>
        </div>
      ) : (
        <form className="ap-form" onSubmit={handleSubmit} noValidate>
          {/* ════ BASIC INFO ════ */}
          <div className="ap-section">
            <div className="ap-grid">
              {/* Product Name */}
              <div className="ap-field ap-field--full">
                <label className="ap-label" htmlFor="prod-name">
                  Product Name *
                </label>
                <div className="ap-input-wrap">
                  <span className="ap-input-icon">
                    <Tag size={15} />
                  </span>
                  <input
                    className={`ap-input ${errors.name ? "ap-input--error" : ""}`}
                    type="text"
                    id="prod-name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (errors.name) setErrors((p) => ({ ...p, name: "" }));
                    }}
                    placeholder="e.g., Modern Velvet Sofa"
                  />
                </div>
                {errors.name && (
                  <span className="ap-error-text">{errors.name}</span>
                )}
              </div>

              {/* Images */}
              <div className="ap-field ap-field--full">
                <label className="ap-label">
                  Product Images *{" "}
                  <span className="ap-img-count">
                    {images.length}/{MAX_IMAGES}
                  </span>
                </label>
                <div className="ap-img-grid">
                  {images.map((file, idx) => (
                    <div key={idx} className="ap-img-thumb">
                      <img
                        src={URL.createObjectURL(file)}
                        alt={`Product ${idx + 1}`}
                      />
                      <button
                        type="button"
                        className="ap-img-thumb-remove"
                        onClick={() => removeImage(idx)}
                        aria-label="Remove image"
                      >
                        <X size={12} />
                      </button>
                    </div>
                  ))}
                  {images.length < MAX_IMAGES && (
                    <button
                      type="button"
                      className="ap-img-add-slot"
                      onClick={() => fileInputRef.current?.click()}
                    >
                      <Plus size={20} />
                      <span>Add</span>
                    </button>
                  )}
                </div>
                <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  accept="image/*"
                  className="ap-img-file-input"
                  onChange={(e) => handleImageFiles(e.target.files)}
                />
                {errors.images && (
                  <span className="ap-error-text">{errors.images}</span>
                )}
                <p className="ap-img-hint">
                  First image is shown as the main product photo.
                </p>
              </div>

              {/* Size */}
              <div className="ap-field ap-field--full">
                <label className="ap-label" htmlFor="prod-size">
                  Size *
                </label>
                <div className="ap-input-wrap">
                  <span className="ap-input-icon">
                    <Ruler size={15} />
                  </span>
                  <input
                    className={`ap-input ${errors.size ? "ap-input--error" : ""}`}
                    type="text"
                    id="prod-size"
                    value={size}
                    onChange={(e) => {
                      setSize(e.target.value);
                      if (errors.size) setErrors((p) => ({ ...p, size: "" }));
                    }}
                    placeholder="e.g., 3-Seater"
                  />
                </div>
                {errors.size && (
                  <span className="ap-error-text">{errors.size}</span>
                )}
              </div>

              {/* Desccription */}
              <div className="ap-field ap-field--full">
                <label className="ap-label" htmlFor="prod-description">
                  Description *
                </label>
                <div className="ap-input-wrap">
                  <span className="ap-input-icon">
                    {/* <Ruler size={15} /> */}
                  </span>
                  <input
                    className={`ap-input ${errors.description ? "ap-input--error" : ""}`}
                    type="text"
                    id="prod-description"
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      if (errors.description)
                        setErrors((p) => ({ ...p, description: "" }));
                    }}
                    placeholder="write the description for product."
                  />
                </div>
                {errors.description && (
                  <span className="ap-error-text">{errors.description}</span>
                )}
              </div>

              {/* Key Features */}
              <div className="ap-field ap-field--full">
                <label className="ap-label" htmlFor="prod-keyFeatures">
                  Key Features *
                </label>
                <div className="ap-input-wrap">
                  <span className="ap-input-icon">
                    {/* <Ruler size={15} /> */}
                  </span>
                  <input
                    className={`ap-input ${errors.keyFeatures ? "ap-input--error" : ""}`}
                    type="text"
                    id="prod-keyFeatures"
                    value={keyFeatures}
                    onChange={(e) => {
                      setKeyFeatures(e.target.value);
                      if (errors.keyFeatures)
                        setErrors((p) => ({ ...p, keyFeatures: "" }));
                    }}
                    placeholder="e.g., Water Resistant, Scratch Proof, Easy to Clean"
                  />
                </div>
                <p className="ap-img-hint">
                  Separate each feature with a comma.
                </p>
                {errors.keyFeatures && (
                  <span className="ap-error-text">{errors.keyFeatures}</span>
                )}
              </div>

              {/* Dimenstions */}
              <div className="ap-field ap-field--full">
                <label className="ap-label" htmlFor="prod-dimensions">
                  Dimensions *
                </label>
                <div className="ap-input-wrap">
                  <span className="ap-input-icon">
                    {/* <Ruler size={15} /> */}
                  </span>
                  <input
                    className={`ap-input ${errors.dimensions ? "ap-input--error" : ""}`}
                    type="text"
                    id="prod-dimensions"
                    value={dimensions}
                    onChange={(e) => {
                      setDimensions(e.target.value);
                      if (errors.dimensions)
                        setErrors((p) => ({ ...p, dimensions: "" }));
                    }}
                    placeholder="e.g., 210cm x 90cm x 85cm"
                  />
                </div>
                {errors.dimensions && (
                  <span className="ap-error-text">{errors.dimensions}</span>
                )}
              </div>

              {/* Product Material -(material k names jo customer ko show hony hain) */}
              <div className="ap-field ap-field--full">
                <label className="ap-label" htmlFor="prod-productMaterial">
                  Product Material Name *
                </label>
                <div className="ap-input-wrap">
                  <span className="ap-input-icon">
                    {/* <Ruler size={15} /> */}
                  </span>
                  <input
                    className={`ap-input ${errors.productMaterial ? "ap-input--error" : ""}`}
                    type="text"
                    id="prod-productMaterial"
                    value={productMaterial}
                    onChange={(e) => {
                      setProductMaterial(e.target.value);
                      if (errors.size)
                        setErrors((p) => ({ ...p, productMaterial: "" }));
                    }}
                    placeholder="e.g., Velvet Fabric, Sheeham Wood"
                  />
                </div>
                {errors.productMaterial && (
                  <span className="ap-error-text">
                    {errors.productMaterial}
                  </span>
                )}
              </div>

              {/* color */}
              <div className="ap-field ap-field--full">
                <label className="ap-label" htmlFor="prod-color">
                  color *
                </label>
                <div className="ap-input-wrap">
                  <span className="ap-input-icon">
                    {/* <Ruler size={15} /> */}
                  </span>
                  <input
                    className={`ap-input ${errors.color ? "ap-input--error" : ""}`}
                    type="text"
                    id="prod-color"
                    value={color}
                    onChange={(e) => {
                      setColor(e.target.value);
                      if (errors.size) setErrors((p) => ({ ...p, color: "" }));
                    }}
                    placeholder="e.g., Emerald Green"
                  />
                </div>
                {errors.color && (
                  <span className="ap-error-text">{errors.color}</span>
                )}
              </div>
            </div>
          </div>

          {/* ════ PRICING ════ */}
          <div className="ap-section">
            <p className="ap-section-label">Pricing</p>
            <div className="ap-field ap-field--full">
              <label className="ap-label" htmlFor="prod-price">
                Price *
              </label>
              <div className="ap-prefix-wrap">
                <span className="ap-prefix">PKR</span>
                <input
                  className={`ap-input ${errors.price ? "ap-input--error" : ""}`}
                  type="number"
                  id="prod-price"
                  value={price}
                  onChange={(e) => {
                    setPrice(e.target.value);
                    if (errors.price) setErrors((p) => ({ ...p, price: "" }));
                  }}
                  placeholder="45000"
                  min="0"
                />
              </div>
              {errors.price && (
                <span className="ap-error-text">{errors.price}</span>
              )}
            </div>
          </div>

          {/* ════ CATEGORY ════ */}
          <div className="ap-section">
            <p className="ap-section-label">Category</p>
            <div className="ap-field">
              <label className="ap-label" htmlFor="prod-category">
                Category *
              </label>
              <div className="ap-input-wrap">
                <span className="ap-input-icon">
                  <LayoutGrid size={15} />
                </span>
                <select
                  className={`ap-select ${errors.category ? "ap-input--error" : ""}`}
                  id="prod-category"
                  value={category}
                  onChange={(e) => {
                    setCategory(e.target.value);
                    if (errors.category)
                      setErrors((p) => ({ ...p, category: "" }));
                  }}
                  style={{ paddingLeft: "2.55rem" }}
                >
                  <option value="">Select category</option>
                  {allCategories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
              {errors.category && (
                <span className="ap-error-text">{errors.category}</span>
              )}
            </div>
          </div>

          {/* ════ Product Materials ════ */}
          <div className="ap-section">
            <p className="ap-section-label">Product Materials</p>
            <p className="ap-pm-hint">
              Define which raw materials are consumed to manufacture one unit of
              this product.
            </p>

            {/* ── Product Materials Input Row ── */}
            <div className="ap-pm-input-card">
              <div className="ap-pm-input-grid">
                {/* Category */}
                <div className="ap-pm-input-field">
                  <label className="ap-pm-field-label">Category</label>
                  <select
                    className="ap-pm-input"
                    value={pmCategory}
                    onChange={(e) => {
                      setPmCategory(e.target.value);
                    }}
                  >
                    <option value="">Select Category…</option>

                    {allCategoriesForMaterial.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* Material dropdown */}
                <div className="ap-pm-input-field">
                  <label className="ap-pm-field-label">Material</label>
                  <select
                    className={`ap-pm-select ${pmErrors.material ? "ap-input--error" : ""}`}
                    value={material}
                    onChange={(e) => setMaterial(e.target.value)}
                    onChange={(e) => {
                      const selected = allMaterial.find(
                        (item) => item.id === e.target.value,
                      );

                      setMaterial(e.target.value);
                      setUnit(selected?.unit || "");
                    }}
                  >
                    <option value="">Select material…</option>
                    {allMaterial?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {pmErrors.material && (
                    <span className="ap-error-text">{pmErrors.material}</span>
                  )}
                </div>

                {/* Quantity */}
                <div className="ap-pm-input-field">
                  <label className="ap-pm-field-label">Qty per Unit</label>
                  <input
                    className={`ap-pm-input ${pmErrors.quantity ? "ap-input--error" : ""}`}
                    type="number"
                    min="0"
                    step="1"
                    placeholder="0"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                  />
                  {pmErrors.quantity && (
                    <span className="ap-error-text">{pmErrors.quantity}</span>
                  )}
                </div>

                {/* Unit — auto fill, read only */}
                <div className="ap-pm-input-field">
                  <label className="ap-pm-field-label">Unit</label>
                  <input
                    className="ap-pm-input ap-pm-input--readonly"
                    value={unit}
                    readOnly
                    placeholder="—"
                    tabIndex={-1}
                  />
                </div>

                {/* Attach button */}
                <div className="ap-pm-input-field ap-pm-attach-wrap">
                  <label className="ap-pm-field-label" aria-hidden="true">
                    &nbsp;
                  </label>
                  <button
                    type="button"
                    className="ap-pm-attach-btn"
                    onClick={handleAttachMaterial}
                    title="Attach material to list"
                    aria-label="Attach material"
                  >
                    <Plus size={18} />
                  </button>
                </div>
              </div>
            </div>

            {/* ── Attached Materials Table ── */}
            {attachedMaterials?.length > 0 && (
              <div className="ap-pm-table-wrap">
                <Table className="ap-pm-table" responsive>
                  <thead>
                    <tr>
                      <th>Material</th>
                      <th>Category</th>
                      <th className="text-center">Quantity</th>
                      <th className="text-center">Unit</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attachedMaterials.map((row) => (
                      <tr key={row.id}>
                        <td className="ap-pm-td-name">
                          {row.admaterial?.name}
                        </td>
                        <td>
                          <span
                            className={`ap-pm-badge ap-pm-badge--`} //${row.category .split(" ")[0] .toLowerCase()}`
                          >
                            {row.admaterial?.adcategory?.name}
                          </span>
                        </td>
                        <td className="text-center">{row.qty}</td>
                        <td className="text-center">
                          <span className="ap-pm-unit">
                            {row.admaterial?.unit || "—"}
                          </span>
                        </td>
                        <td className="text-center">
                          <button
                            type="button"
                            className="ap-pm-delete-btn"
                            onClick={() => handleDeleteMaterial(row.id)}
                            aria-label={`Remove ${row.material}`}
                          >
                            <X size={13} />
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>

          {/* ── Form Actions ── */}
          <div className="ap-actions">
            <button
              type="button"
              className="ap-cancel-btn"
              onClick={handleClose}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button type="submit" className="ap-save-btn" disabled={isSaving}>
              {isSaving ? "Adding…" : "Add Product"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AddProduct;
